/**
 * A room's floor polygon, as the plan-view ring `[{x, z}, ...]`.
 *
 * Rooms persist one floor per storey slab, each with `polygonCorners`; a
 * split-level or a room with a mezzanine slab can carry more than one, and
 * the LARGEST is the room's footprint. Corners come either as `{x, y, z}`
 * objects or as `[x, y, z]` triples depending on the writer, so both are
 * read. Lifted out of `kitchen-assembly/wallBodies` once the tub surround
 * needed the same answer.
 */

const polygonArea = (poly) => {
  let sum = 0;
  for (let i = 0; i < poly.length; i++) {
    const j = (i + 1) % poly.length;
    sum += poly[i].x * poly[j].z - poly[j].x * poly[i].z;
  }
  return Math.abs(sum) / 2;
};

/** Largest floor polygon of a room, as `[{x, z}, ...]`, or null. */
function floorPolygonOf(roomData) {
  const polys = (roomData?.floors || [])
    .map((f) =>
      (f?.polygonCorners || []).map((c) => ({
        x: c.x ?? c[0],
        z: c.z ?? c[2],
      }))
    )
    .filter((p) => p.length >= 3);
  if (polys.length === 0) return null;
  return polys.sort((a, b) => polygonArea(b) - polygonArea(a))[0];
}

module.exports = { floorPolygonOf, polygonArea };
